import axios from 'axios'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_KEY,
  headers: {
    'x-api-key': import.meta.env.VITE_X_API_KEY,
  },
})

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

export async function addViews(projectId) {
  return (await api.get(`/add-views/${projectId}`)).data
}
